import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'

import './LinearProgress.scss'

const LinearProgress = forwardRef(function LinearProgress(props, ref) {
	const { className, style, value, indeterminate, ...other } = props

	const rootProps = {}

	if (value) {
		rootProps['aria-valuenow'] = Math.round(value)
		rootProps['aria-valuemin'] = 0
		rootProps['aria-valuemax'] = 100
	}

	return (
		<div
			ref={ref}
			role="progressbar"
			className={clsx('Vb-linearprogress', className)}
			style={style}
			{...rootProps}
			{...other}
		>
			<div style={{ transform: `translateX(${Math.round(value) - 100}%)` }}>
				{indeterminate && (
					<span className={clsx('Vb-linearprogress-indeterminate', className)} />
				)}
			</div>
		</div>
	)
})

export default LinearProgress

LinearProgress.propTypes = {
	/**
	 * @ignore
	 */
	className: PropTypes.string,

	/**
	 * The value of the progress indicator for the determinate and buffer variants. 
	 * Value between 0 and 100
	 */
	value: PropTypes.number,

	/**
	 * @ignore
	 */
	style: PropTypes.object,

	/**
   * Use indeterminate animation.
   */
	indeterminate: PropTypes.bool
}